module.exports = __webpack_public_path__ + "static/media/no-offers.0ee7b0fc.svg";